class Group {
  public id: number;

  public title: string = '';

  public watchers: number[] = [];

  public members: number[] = [];

  public admins: number[] = [];

  public functions: number[] = [];

  public isPublic: boolean;

  public memoFormat: string = '';

  public archived: boolean;
}

export default Group;



// WEBPACK FOOTER //
// ./src/entities/Group.ts